import React, { useState, useEffect } from "react";
import NearestDentist from "../nearestDentist";
import WPLink from "../wpLink";
import DroidalLink from "../droidalLink";
import Submenu from "../submenu";
import FixedImage from "../fixedImage";
import { Link } from "gatsby";
import useModalState from '../../helpers/modalState';


import * as styleSheet from "./index.module.scss"

const DesktopNav = ({mainNavigationSettings, services, locations, dentists, arrowBlue, arrowGreen, arrowRedLocal, arrowGrayLocal, locationsPage = null, teamPage = null, zip }) => {
	const {
		showLocationsInMenu,
		showServicesInMenu,
 		showTeamInMenu,
		servicesMegamenu: {
		  featuredServices,
		  servicesList
		},
		servicesMenuTitle,
		navCta,
		links,
		locationsMenuTitle,
		teamMenuTitle,
	} = mainNavigationSettings;


	const [showAppointmentModal, setShowAppointmentModal] = useModalState();

	function showModal(){
		  if( !showAppointmentModal.modalOpen ){
			  setShowAppointmentModal({modalOpen: true, zipcode: zip});
		  }
	  }
  
	function handleApptKeyDown(e) {
	  if (e.keyCode === 13 || e.keyCode === 32) {
			  setShowAppointmentModal({modalOpen: true, zipcode: zip});
		  }
	}


	const [ servicesOpen, setServicesOpen ] = useState(false);
	const [ teamOpen, setTeamOpen ] = useState(false);

	const [ servicesLinkActive, setServicesLinkActive ] = useState(false);
	const [ locationsLinkActive, setLocationsLinkActive ] = useState(false);
	const [ teamLinkActive, setTeamLinkActive ] = useState(false);

	const toggleServices = () => {
		const toggled = !servicesOpen;
		setTeamOpen(false);
		setServicesOpen(toggled);
	};

	const toggleTeam = () => {
		const toggled = !teamOpen;
		setServicesOpen(false);
		setTeamOpen(toggled);
	};

	useEffect( () => {
		const setActiveLinks = () => {
			if( window.location.pathname.includes("/location/") || (locationsPage !== null && locationsPage.nodes.length > 0 && window.location.pathname.includes(locationsPage.nodes[0].link) ) ){
				setLocationsLinkActive(true);
			}

			if( window.location.pathname.includes("/service/") ){
				setServicesLinkActive(true);
			}

			if( window.location.pathname.includes("/dentist/") || (teamPage !== null && teamPage.nodes.length > 0 && window.location.pathname.includes(teamPage.nodes[0].link) ) ){
				setTeamLinkActive(true);
			}
		};

		if( typeof window !== undefined ){
			setActiveLinks();
		}
	}, [locationsPage, teamPage]);




	useEffect( () => {
		dentists.sort(function(a, b){
			var keyA = a.ACFDentist.lastName,
				keyB = b.ACFDentist.lastName;
			if(keyA < keyB) return -1;
			if(keyA > keyB) return 1;
			return 0;
		});

	}, [dentists])


  	return (
		<nav className={styleSheet.DesktopNav} role="navigation">
			<ul className={styleSheet.navlist}>

				{ showServicesInMenu && (
					<li className={styleSheet.navlistitem}>
						<button 
							className={servicesOpen ? styleSheet.togglelinkactive : servicesLinkActive ? styleSheet.toggleLinkNavActive : styleSheet.togglelink} 
							onClick={(event)=>{
								event.preventDefault();
								toggleServices();
						}}>{servicesMenuTitle}</button>
						<button aria-label="close modal" className={  servicesOpen ? `${styleSheet.shroud} ${styleSheet.shroudopen}` : `${styleSheet.shroud}`}  onClick={() => { toggleServices(); }} onKeyDown={(event) => { if (event.keycode === 13){ toggleServices(); }}} tabIndex={0}></button> 
						<Submenu showIf={servicesOpen} setInsuranceIsOpen={setServicesOpen} passedClass={styleSheet.services}>
							<div className={styleSheet.inner}>
								<div className={styleSheet.left}>
									<span className={styleSheet.heading}>Featured Services</span>
									<p className={styleSheet.disclaimer}>Services vary per clinic.</p>
									<div className={styleSheet.servicescontainer}>
										{ featuredServices && featuredServices.map((service, index) => {
											return (
												<div key={`ftsrvc-'${service.id}`} className={styleSheet.featuredservice}>
													<Link to={service.link} className={styleSheet.title}>{service.title } <FixedImage passedClass={styleSheet.icon} image={arrowGreen} /></Link>
													{ service.ACFService.briefDescription && <p dangerouslySetInnerHTML={{__html: service.ACFService.briefDescription}}></p>}
												</div>
											)
										})}
									</div>
								</div>
								<div className={styleSheet.right}>
									<span className={styleSheet.heading}>Find more services.</span>
									<ul className={styleSheet.list}>
										{ servicesList ? servicesList.map((service, index) => {
											return (
												<li key={`lstsrvc-'${service.id}`} className={styleSheet.listitem}>
													<Link to={service.link} className={styleSheet.link}>
														<FixedImage passedClass={styleSheet.icon} image={arrowBlue} />
														<span className={styleSheet.title} dangerouslySetInnerHTML={{__html: service.title }}></span>
													</Link>	
												</li>
											)
										}) : services.map((service, index) => {
											return (
												<li key={`lstsrvc-'${service.id}`} className={styleSheet.listitem}>
													<Link to={service.link} className={styleSheet.link}>
														<FixedImage passedClass={styleSheet.icon} image={arrowBlue} />
														<span className={styleSheet.title} dangerouslySetInnerHTML={{__html: service.title }}></span>
													</Link>	
												</li>
											)
										})}
									</ul>
						</div>
					</div>
				</Submenu>
				</li>
			)}

				{ showLocationsInMenu && (
					<li className={styleSheet.navlistitem}>
						<Link to="/locations/" className={locationsLinkActive ? styleSheet.linkNavActive : styleSheet.link}>{locationsMenuTitle}</Link>
					</li>
				)}
				{ showTeamInMenu && (
					<li className={styleSheet.navlistitem}>
						<button 
							className={teamOpen ? styleSheet.togglelinkactive : teamLinkActive ? styleSheet.toggleLinkNavActive : styleSheet.togglelink } 
							onClick={(event)=>{
								event.preventDefault();
								toggleTeam();
						}}>{teamMenuTitle}</button>
						<button aria-label="close modal" className={  teamOpen ? `${styleSheet.shroud} ${styleSheet.shroudopen}` : `${styleSheet.shroud}`}  onClick={() => { toggleTeam(); }} onKeyDown={(event) => { if (event.keycode === 13){ toggleTeam(); }}} tabIndex={0}></button> 
						<Submenu showIf={teamOpen} setInsuranceIsOpen={setTeamOpen} passedClass={styleSheet.team}>
							<div className={styleSheet.inner}>
								<div className={styleSheet.left}>
									<span className={styleSheet.heading}>Featured Team Member</span>
									<NearestDentist locations={locations} dentists={dentists} arrowRedLocal={arrowRedLocal} arrowGrayLocal={arrowGrayLocal} />
								</div>
								<div className={styleSheet.right}>
									<span className={styleSheet.heading}>Find more team members.</span>
									<ul className={styleSheet.list}>
										{ dentists && dentists.map((dentist, index) => {
											return (
												<li key={`lstdnt-'${dentist.id}`} className={styleSheet.listitem} style={{maxWidth: dentists.length > 12 ? '50%' : '100%' }}>
													<Link to={dentist.link} className={styleSheet.link}>
														<FixedImage passedClass={styleSheet.icon} image={arrowBlue} />
														<span className={styleSheet.title} dangerouslySetInnerHTML={{__html: dentist.title }}></span>
													</Link>	
												</li>
											)
										})}
									</ul>
								</div>
							</div>
						</Submenu>
					</li>
				)}
				{
					links && links.map( (link, index) => {
						return <li key={`${link.link.url}`} className={styleSheet.navlistitem}><WPLink key={`extralink-${index}`} link={link.link} passedClass={styleSheet.link} passedActiveClass={styleSheet.linkNavActive} /></li>;
					})
				}
				{
					navCta && (
						<li className={styleSheet.navlistitemcta}>{navCta?.url.includes('schedule-online') ? <DroidalLink text={navCta.title} passedClass={styleSheet.cta} /> : <WPLink link={navCta} passedClass={styleSheet.cta} />}</li>
					)
				}
			</ul>
		</nav>
	);
}

export default DesktopNav;
